import SaveButton from "@/components/button/save-button";
import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";
import { MealTimeSegmentButtons } from "@/components/segment-buttons/meal-time-segment-buttons";
import useGoToFoodProfile from "@/features/go-to/hooks/use-go-to-food-profile";
import { IonSkeletonText, useIonRouter } from "@ionic/react";
import { FormProvider } from "react-hook-form";
import { MealGroupList } from "../../components/meal-group-list";

export default function GoToFoodProfile() {
  const navigation = useIonRouter();
  const { mealTime, form, handleFormSubmit, isGenerating, isValid, isLoading } =
    useGoToFoodProfile({
      onSuccess: () => {
        navigation.push("/profiling/go-to/candidates-creating", "forward");
      },
    });

  return (
    <PageContainer>
      <PageTitleComponent
        title="My Favourites"
        description="Add your favourite meals that you want to include in your meal plan."
      />

      <MealTimeSegmentButtons selected={mealTime} />
      <FormProvider {...form}>
        <form
          className="w-full flex-1 flex flex-col gap-4 justify-between"
          onSubmit={handleFormSubmit}
        >
          {isLoading ? (
            <div className="w-full flex flex-col gap-4">
              <IonSkeletonText animated className="h-16" />
              <IonSkeletonText animated className="h-16" />
              <IonSkeletonText animated className="h-16" />
              <IonSkeletonText animated className="h-16" />
            </div>
          ) : (
            <MealGroupList />
          )}

          <SaveButton
            text="Save & Continue"
            type="submit"
            position="fixed"
            disabled={isGenerating || !isValid || isLoading}
          />
        </form>
      </FormProvider>
    </PageContainer>
  );
}
